export default {
  "hierarchy": {},
  "props": {
    "default": {}
  }
}